import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './upsertPopMutation.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type UpsertPopMutation_upsertPop_MenuItem_userPop_Pop = {
  __typename: 'Pop',
  id: number,
  popType: string
};

export type UpsertPopMutation_upsertPop_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  popsCount: number,
  userPop?: UpsertPopMutation_upsertPop_MenuItem_userPop_Pop | null
};

export type UpsertPopMutation_Mutation = {
  __typename?: 'Mutation',
  upsertPop: UpsertPopMutation_upsertPop_MenuItem
};


export type UpsertPopMutationVariables = Types.Exact<{
  menuItemId: Types.Scalars['Int']['input'];
  popType: Types.PopPopType;
}>;


export type UpsertPopMutation = UpsertPopMutation_Mutation;


export const UpsertPopDocument = /*#__PURE__*/ document as unknown as DocumentNode<UpsertPopMutation, UpsertPopMutationVariables>;

export type UpsertPopMutationFn = ApolloReactCommon.MutationFunction<UpsertPopMutation, UpsertPopMutationVariables>;

/**
 * __useUpsertPopMutation__
 *
 * To run a mutation, you first call `useUpsertPopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPopMutation, { data, loading, error }] = useUpsertPopMutation({
 *   variables: {
 *      menuItemId: // value for 'menuItemId'
 *      popType: // value for 'popType'
 *   },
 * });
 */
export function useUpsertPopMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertPopMutation, UpsertPopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertPopMutation, UpsertPopMutationVariables>(UpsertPopDocument, options);
      }
export type UpsertPopMutationHookResult = ReturnType<typeof useUpsertPopMutation>;
export type UpsertPopMutationResult = ApolloReactCommon.MutationResult<UpsertPopMutation>;
export type UpsertPopMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertPopMutation, UpsertPopMutationVariables>;